import {
  makeStyles
} from '@material-ui/core/styles';
import LandingBackground from '../assets/img/Slide_1.jpg'
import Slide2Background from '../assets/img/Slide_2.jpg'

export const useDialogStyles = makeStyles(
  (theme) => ({
    dialogWrapper: {
      backgroundColor: '#fff',
      paddingBottom: 20,
      borderRadius:'25px',
      overflow: 'hidden',
      [theme.breakpoints.down('xs')]: {
        padding: 0,
      },
    },
  }), {
    index: 1
  }
);

export const useMessagesStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      width: '91vW',
      height: '93vH',
    },
    leftPanel: {
      width: '40%',
      borderRight: theme.palette.type === 'dark' ?
        '2px solid #d3d3d315' : '2px solid #d3d3d395',
    },
    leftPanelContent: {
      maxHeight: 'calc(100vH - 111px)',
      minHeight: 'calc(100vH - 111px)',
      overflowY: 'auto',
    },
  }), {
    index: 1
  }
);

export const useTabBarStyles = makeStyles(
  (theme) => ({
    root: {
      [theme.breakpoints.down('sm')]: {
        top: '51px',
        zIndex: 10,
      },
    },
    tabs: {
      borderBottom: theme.palette.type === 'dark' ?
        '1px solid #d3d3d320' : '1px solid #d3d3d395',
    },
    tab: {
      [theme.breakpoints.up('sm')]: {
        minWidth: 50,
        minHeight: 56,
      },
      fontWeight:'600 ',
    },
  }), {
    index: 1
  }
);

export const useMenuStyles = makeStyles(
  (theme) => ({
    avatar: {
      marginRight: '0.2em',
      width: theme.spacing(2.8),
      height: theme.spacing(2.8),
    },
    moreBtn: {
      padding: '0.35em',
    },
    userBtnMob: {
      padding: '0.35em',
    },
    iconBtn: {
      [theme.breakpoints.down('sm')]: {
        padding: '0.1em',
      },
    },
    menuIcon: {
      marginRight: '8px',
    },
  }), {
    index: 1
  }
);

export const useAuthFormStyles = makeStyles(
  (theme) => ({
    root: {
      color: '#fff',
      padding: '4em',
      '& .MuiInputBase-root': {
        color: 'white',
      }, 
      '& .MuiFormLabel-root': {
        color: 'white',
      },
      '& label.Mui-focused': {
        color: 'white',
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: 'white',
        },
        '&:hover fieldset': {
          borderColor: '#3e3799',
        },
      },
      '& .MuiSvgIcon-root':{
        fill:'white'
      },
      
      [theme.breakpoints.down('xs')]: {
        padding: '10% 0 0 0',
      },
      
    },
    column:{
      flex:'50%',
      [theme.breakpoints.down('md')]: {
        flex: '100%',
      },
    },
    row:{
      display:'flex',
      flexWrap:'wrap',
      height:'80vH',

      [theme.breakpoints.down('xs')]: {
        padding:'1em',
      },
    },
    form: {
      color: '#fff',
      marginTop: '3em',
    },
    inputField: {
      marginBottom: '1.5em',
      color: '#fff',
    },
    submitButton: {
      color: '#fff',
      marginTop: '0.5em',
      height: '3.1em',
      fontSize: '1em',
      fontWeight: 500,
    },
    title: {
      color: "#ffc922",
      textShadow: '2px 2px white',
      fontWeight:'bold',
      fontSize: 'calc(40px + 4vw)',
      letterSpacing:'3px'
    },
    register:{
      color: "#ffc922",
      textShadow: '2px 2px white',
      fontWeight:'bold',
      fontSize: 'calc(40px + vw)',
      letterSpacing:'3px'
    },
    footerText: {
      color: '#fff',
      margin: '1.5em 0',
      textAlign: 'center',
    },
    link: {
      color: '#fff',
      cursor: 'pointer',
    },
    homeVector:{
      width:'45vW',
      position: 'absolute',
      top:'20%',
      left:'7%',
      [theme.breakpoints.down('md')]: {
        display:'none'
      },
      textField:{
        
      }
    }
  }), {
    index: 1
  }
);

export const useChatListStyles = makeStyles(
  (theme) => ({
    root: {
      width: '100%',
    },
    listItem: {
      display: 'flex',
    },
    chatInfo: {
      width: '100%',
    },
    nameAndDate: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    greyText: {
      color: '#5B5A5A',
    },
    infoText: {
      padding: '0.5em',
      textAlign: 'center',
    },
    wrapper: {
      padding: '0.3em 0.4em',
    },

  }), {
    index: 1
  }
);

export const useConversationPageStyles = makeStyles(
  (theme) => ({
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        width: 'auto',
        borderRight: 'none',
        
      },
    },
    conversationWrapper: {
      padding: '.5em 1em',
      overflowY: 'auto',
      flexGrow: 1,
      [theme.breakpoints.down('sm')]: {
        maxHeight: 'calc(97.5vH - 122px)',
        minHeight: 'calc(97.5vH - 122px)',
      },
    },
    noMessages: {
      display: 'flex',
      alignItems:'center',
      justifyContent:'center',
      height: 'calc(100vH - 181px)',
      padding: '1em',
      paddingTop: '2em',
      [theme.breakpoints.down('lg')]: {
        height:'calc(97.5vH - 130px)',
      }, 
      [theme.breakpoints.down('md')]: {
        height:'calc(97.5vH - 135px)',
      },
      [theme.breakpoints.down('sm')]: {
        height:'calc(97.5vH - 140px)',
      },
      
      
    },
    dateInfoWrapper: {
      margin: '2em 0 -4em 0',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    infoText: {
      margin: 'auto auto 1em auto',
      backgroundColor: theme.palette.type === 'dark' ?
        theme.palette.secondary.main : "ffff",
      color: '#333',
      padding: '0.4em 0.8em',
      borderRadius: 8,
      border: `1px solid ${theme.palette.primary.main}40`,
    },
    selectChatText: {
      margin: '1em',
      fontWeight:'bold',
      padding: '0.4em 0.8em',
      textAlign:'center',
      borderRadius: 8,
      border: `1.5px solid #16A79E`,
    },
    msgMarginSameUser: {
      marginTop: '0.2em',
      marginBottom: '0.2em',
    },
    msgMarginDiffUser: {
      marginTop: '3.5em',
      marginBottom: '0.2em',
    },
    messageWrapper: {
      display: 'flex',
      marginLeft:'3em'
    },
    privateMessageWrapper: {
      display: 'flex',
      marginLeft:'3em',
    },
    msgTime: {
      fontSize: '0.6em',
      marginTop: '0.3em',
    },
    sentMsg: {
      marginRight:'.5em',
      padding: '0.4em 1em',
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      borderRadius: 10,
      marginLeft: 'auto',
      maxWidth: '88%',
      display: 'flex',
      alignItems: 'flex-end',
      flexWrap: 'wrap', 
  
    },
    receivedMsg: {
      padding: '0.4em 1em',
      backgroundColor: theme.palette.type === 'dark' ? '#555' : '#e3e3e3',
      borderRadius: 10,
      marginRight: 'auto',
      maxWidth: '88%',
      display: 'flex',
      alignItems: 'flex-end',
      flexWrap: 'wrap',
    },
    msgText: {
      wordWrap: 'anywhere',
      marginRight: '0.5em',
    },
    conversationHeader: {
      display: 'flex',
      padding: '1em 1em',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: theme.palette.type === 'dark' ?
        '1px solid #d3d3d320' : '1px solid #d3d3d395',
      [theme.breakpoints.down('sm')]: {
        // width: '100%',
        // position: 'fixed',
        padding: '0.5em 0.2em',
        borderBottom: `3px solid ${theme.palette.primary.main}98`,
      },
    },
    avatar: {
      [theme.breakpoints.down('sm')]: {
        width: '1.5em',
        height: '1.5em',
      },
    },
    headerTitle: {
      display: 'flex',
      alignItems: 'center',
      padding: '0 0.4em',
    },
    leftBtns: {
      display: 'flex',
      alignItems: 'center',
    },
    rightHeaderBtns: {
      display: 'flex',
      alignItems: 'center',
    },
    titleText: {
      marginLeft: '0.8em',
      marginRight: '0.7em',
      fontWeight:'bold',
      [theme.breakpoints.down('sm')]: {
        marginLeft: '0.5em',
      },
    },
    subTitleText: {
      marginLeft: '1.5em',
      marginRight: '0.7em',
      fontWeight:'bold',
      [theme.breakpoints.down('sm')]: {
        marginLeft: '0.5em',
      },
    },
    sendMsgForm: {
      '& .MuiOutlinedInput-multiline':{
        padding:'5px',
      },
      "& .MuiOutlinedInput-input": {
        background: "#e3e0d8",
        padding:'10px 14px',
        borderRadius:'15px'
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          border:'none'
        },
        '&:hover fieldset': {
          borderColor: 'none'
        },
      },

      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        margin: 0,
      },
    },
    
  }), {
    index: 1
  }
);

export const useGroupInfoStyles = makeStyles(
  (theme) => ({
    topPart: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      textAlign: 'center',
    },
    groupIcon: {
      width: 60,
      height: 60,
    },
    groupName: {
      marginBottom: '0.5em',
      display: 'flex',
    },
    btnGroup: {
      display: 'flex',
      marginBottom: '0.5em',
    },
    editBtn: {
      marginRight: '0.7em',
    },
    membersListWrapper: {
      margin: '0 auto',
      width: '100%',
      border: '1px solid #d3d3d3',
      marginTop: '1.2em',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    membersList: {
      overflowY: 'auto',
      maxHeight: '250px',
      [theme.breakpoints.down('sm')]: {
        maxHeight: '200px',
      },
    },
    membersHeader: {
      textAlign: 'center',
      borderBottom: '1px solid #d3d3d3',
    },
    updateNameBtns: {
      marginTop: 2,
      display: 'flex',
      justifyContent: 'space-between',
    },

  }), {
    index: 1
  }
);

export const useAddGroupMembersStyles = makeStyles(
  (theme) => ({
    addMemberBtn: {
      marginTop: '2em ',
    },
  }), {
    index: 1
  }
);

export const useCreateGroupStyles = makeStyles(
  (theme) => ({
    textField: {
      marginBottom: '1.5em',
    },
    submitBtn: {
      marginTop: '1.5em',
    },
  }), {
    index: 1
  }
);

export const useEmojiPanelStyles = makeStyles(
  (theme) => ({
    emojiWrapper: {
      display: 'grid',
      gridTemplateColumns: 'repeat(5, auto)',
      gridGap: '5px',
    },
    emojiBtn: {
      fontSize: '1.3em',
    },
  }), {
    index: 1
  }
);

export const useMainPageStyles = makeStyles(
  (theme) => ({
    box: {
      position: 'absolute',
      height: '97vH',
      left: '6vW',
      top: '2vH',
      right:'2vw',
      padding:'.5em',
      backgroundColor: '#ffff',
      boxSizing: 'border-box',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
      borderRadius: '30px',
      [theme.breakpoints.down('md')]: {
        margin:'0 2vH',
        width:'90vW',
      },
    },
    
  }), {
    index: 1
  }
);
export const useMobileStyles = makeStyles(
  (theme) => ({
    root:{
      backgroundColor: '#fff',
      minHeight:'100vh'
    },
  })
)
export const useMobileNavStyles = makeStyles(
  (theme) => ({
    stickToBottom:{
      display: 'flex',
      justifyContent: 'space-around',
      width: '100%',
      position: 'fixed',
      bottom: 4,
      
    },
    display:{
      display:'none',
    }
  })
)
export const useProfileStyles = makeStyles(
  (theme) => ({
    topPart: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      textAlign: 'center',
    },
    avatarDesktop: {
      width: theme.spacing(15),
      height: theme.spacing(15),
      margin: '2%',
      borderRadius: 80,
      fontSize:'4em'
    },
    avatarMobile: {
      width: theme.spacing(10),
      height: theme.spacing(10),
      margin: '2%',
      fontSize:'4em',
      borderRadius: 80,
    },
    text: {
      fontSize: '1.5em',
      margin:'.5em 0',
    },
    logoutBtn: {
      marginBottom: '.5em'
    },
  })
);
export const useVirtualRoomStyles = makeStyles(
  (theme) => ({
    row:{
      display:'flex',
      flexWrap:'wrap',
      height:'80vH',
      margin:'2vH',
      flexDirection:'row-reverse',
      [theme.breakpoints.down('md')]: {
        margin:'0 2vH',
      },
      
    },
    column:{
      flex:'50%',
      [theme.breakpoints.down('md')]: {
        flex: '100%',
      },
    },
    title:{
      fontSize: '4rem',
      marginTop:'0',
      letterSpacing:'.3vw',
      [theme.breakpoints.down('xl')]: {
        fontSize: '6rem',
        margin: '1vw' ,
        marginBottom:'0',
      },
      [theme.breakpoints.down('lg')]: {
        marginTop:'2em',
        fontSize: '3em',
        marginBottom:'1em',
      },
      [theme.breakpoints.down('md')]: {
        fontSize: '8vw',
        margin:0,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '2em',
        marginTop:'1em',
        marginBottom:'1em',
        margin:'calc(30vH - 150px) 0',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '1.5em',
        marginTop:'1em',
        marginBottom:'1em',
        margin:'calc(30vH - 150px) 0',
      },
      
      
  },
    join:{
        marginTop: '.5rem ',
        padding: '.9rem',
        borderRadius: '10px',
        color: 'white',
        backgroundColor:' #16A79E',
        outline: 'none',
        fontWeight: 'bold',
        border: 'none',
        '&:hover': {
          backgroundColor: '#7ED4CF',
        },
      
        [theme.breakpoints.down('md')]: {
          marginTop: '2em ',
        },
        [theme.breakpoints.down('sm')]: {
          padding: '.4em',
          marginTop: '2em ',
        },
    },
    virtualVector:{
      marginLeft:'5vw',
      marginTop:'7em',
      height:'30vw',
      [theme.breakpoints.down('md')]: {
        display:'none',
      },
    }
  
  })
);
export const useNotFoundStyles = makeStyles(
  (theme) => ({
    root:{
      display:'flex',
      alignItems:'center',
      justifyContent:'center',
      flexDirection:'column',
      marginTop:'-8vw',
      width:'100vw',
      height:'100vh',
      color:'#fff',
      '& .MuiInputBase-root': {
        color: 'white',
      }, 
      '& .MuiFormLabel-root': {
        color: 'white',
      },
      '& label.Mui-focused': {
        color: 'white',
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: 'white',
        },
        '&:hover fieldset': {
          borderColor: '#3e3799',
        },
      },
      '& .MuiSvgIcon-root':{
        fill:'white'
      },
      
      [theme.breakpoints.down('xs')]: {
        padding: '10% 0 0 0',
      },
      
    },
  })
);

export const useHomeStyles = makeStyles(
  (theme) => ({
    root:{
      display:'flex',
      alignItems:'center',
      justifyContent:'center',
      flexDirection:'column',
    },
    footer:{
      display:'flex',
      justifyContent:'space-around'
    },
    row:{
      display:'flex',
      flexWrap:'wrap',
      paddingTop:'-vh'
    },
    column:{
      flex:'50%',
      [theme.breakpoints.down('md')]: {
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        flexDirection:'column',
        flex:'100%',
        fontSize:"2vw",
        
      },

    },
    titleFontSize:{
      letterSpacing:'.3vw',
      paddingBottom:'1vw',
      fontWeight: 'bolder',
      fontSize:'5vw',
      [theme.breakpoints.down('md')]: {
        paddingTop:'6vh',
        
      },
    },
    DescriptionFontSize:{
      wordSpacing:' .50vw',
      paddingTop:'5vh',
      paddingBottom:'3vh',
      [theme.breakpoints.down('md')]: {
        fontSize:'3vw',
        paddingTop:'3vh',

        
      },
    },
    slideTextRight:{
      padding:' 5vh 15vh 0 0',
      [theme.breakpoints.down('md')]: {
        padding:' 1vh 0 0 4vh'
      },
    },
    slideTextLeft:{
      padding:' 5vh 0 0 15vh',
      [theme.breakpoints.down('md')]: {
        padding:' 1vh 0 0 4vh'
      },
    },
    Vectors:{
      width:'40vW', 
      position: 'static',
      [theme.breakpoints.down('md')]: {
        width:'calc(70vH - 150px) ',
      },

    },
    
    navbar:{
      display:'flex', 
      justifyContent:'space-between',
      padding:'2vh'
    },
    logoFlex:{
      display:'flex',
      alignItems:'center',
      
    },
    logo:{
      width:'2vw',
      margin:'0 .5vw 0 2vw',
      [theme.breakpoints.down('md')]: {
        width:'4vw',
      },
    },
    logoName:{
      color:'white',
      letterSpacing:'.3vw'
    },
    
   
    
  })
);
